import { ShipmentQuickFilters } from '../../../../models';
import { DemurrageDetentionStatusEnum } from './demurrage-detention-status.model';

export interface ShipmentQuickFilterModel {
  name: ShipmentQuickFilters | DemurrageDetentionStatusEnum;
  count: number;
  active: boolean;
}
